<template>
    <b-card>
        <!-- Order Import Card -->
        <div class="card-body">

            <file-upload
                title="Upload een bestand om orders te importeren. Ondersteunde formaten: Excel (.xlsx, .xls)"
                :url="getUrl()"
                :instructions="instructions"
                accept=".xlsx,.xls"
                @success="onUploadSuccess"
                @error="onUploadError"
                @reset="onReset"
            ></file-upload>

            <div v-if="uploadStatus === 'success'" class="alert alert-success status-message mt-4">
                <h4 class="instructions-title">
                    <font-awesome-icon icon="check-circle"/>
                    Bestand {{ this.file.name }} is succesvol geüpload en verwerkt
                </h4>
                <b-link :to="orderLink(salesOrder.identifier)">Ga naar de order</b-link>
            </div>

            <div v-if="uploadStatus === 'error'" class="alert alert-danger status-message mt-4">
                <h4 class="instructions-title">
                    <font-awesome-icon icon="times-circle"/>
                    Bestand {{ this.file.name }} is niet verwerkt
                </h4>
                <ul v-if="uploadMessage" class="instructions-list">
                    <li>{{ uploadMessage }}
                        <ul>
                            <li v-for="(info, index) in additionalInfo" :key="index">{{ info }}</li>
                        </ul>
                    </li>
                </ul>
            </div>

        </div>
    </b-card>
</template>

<script>

import FileUpload from "@/components/FileUpload.vue";

export default {
    name: "SalesOrderFileImport",
    components: {FileUpload},

    props: {
        location: {required: false},
    },

    data() {
        return {
            uploadStatus: "",
            file: "",
            errors: [],
            uploadMessage: "",
            additionalInfo: [],
            salesOrder: null,

            instructions: [
                'De bestandsnaam begint met het ordernummer, het ordernummer moet 6 cijfers zijn en beginnen met een 2',
                'Het ordernummer is uniek',
                'De klantnaam staat op positie B2',
                'De plaatsnaam staat op positie K2',
                'Het bestand bevat de juiste kolommen'
            ],
        }
    },

    methods: {
        getUrl: function() {
            return `/api/omt/${this.location.location_type.identifier}/${this.location.identifier}/sales-orders/import-file`;
        },
        orderLink(orderIdentifier) {
            return {
                name: 'OrderDetailOverview',
                params: {
                    salesOrderIdentifier: orderIdentifier,
                }
            }
        },
        onUploadSuccess(file, response) {
            this.uploadStatus = "success"
            this.file = file
            this.salesOrder = response.data.sales_order
        },
        onUploadError(file, exception) {
            this.uploadStatus = "error"
            this.file = file
            this.uploadMessage = exception.response.data.message
                ? exception.response.data.message
                : exception.response.data.errors[0].message
            this.additionalInfo = exception.response.data.additionalInfo
        },
        onReset() {
            this.uploadStatus = ""
            this.file = null
            this.uploadMessage = ""
            this.additionalInfo = []
            this.salesOrder = null
        },
    },
}
</script>

<style scoped>

.status-message {
    gap: 0.5rem;
}

.instructions-title {
    font-size: 1rem;
    margin-bottom: 0.5rem;
}

</style>